// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SegmentPickerInner__wrapper___dsQMV","list-wrapper":"SegmentPickerInner__list-wrapper___Sonrg","center":"SegmentPickerInner__center___OPFO2"};